function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 7H15L9.5 1.5V7ZM2.5 0H10.5L16.5 6V18C16.5 18.5304 16.2893 19.0391 15.9142 19.4142C15.5391 19.7893 15.0304 20 14.5 20H2.5C1.96957 20 1.46086 19.7893 1.08579 19.4142C0.710714 19.0391 0.5 18.5304 0.5 18V2C0.5 0.89 1.39 0 2.5 0ZM2.62 13.5L6.36 17.24L7.78 15.83L5.45 13.5L7.78 11.17L6.36 9.76L2.62 13.5ZM13.78 13.5L10.04 9.76L8.62 11.17L10.95 13.5L8.62 15.83L10.04 17.24L13.78 13.5Z",
  fill: "white"
});
function SvgXmlResp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlResp);
export default __webpack_public_path__ + "static/media/XML-resp.2bd00386eb87dc88f5d75e68ad1cabf6.svg";
export { ForwardRef as ReactComponent };